export default __webpack_public_path__ + "locales/lo-LA/ChangeUserTypeDialog.json?hash=a9497e43eacc62f3b6e37f3162faa5f7";